import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaDiscord, FaTelegram, FaReddit } from 'react-icons/fa';
import { BiLogoMediumOld } from "react-icons/bi";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="footer-main">
              <div className="footer-left">
              © Copyright {new Date().getFullYear()} Bearth NFT All Rights Reserved.
            </div>
            <div className="footer-social">
              <a href="https://www.facebook.com/profile.php?id=61578662374162" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
              <a href="https://www.instagram.com/bearth_nft/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://x.com/Bearth_nft" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
              <a href="https://discord.com/invite/n3NmwSzA" target="_blank" rel="noopener noreferrer"><FaDiscord /></a>
              <a href="https://t.me/bearth_nft" target="_blank" rel="noopener noreferrer"><FaTelegram /></a>
              <a href="https://www.reddit.com/r/Bearth/" target="_blank" rel="noopener noreferrer"><FaReddit /></a>
              <a href="https://medium.com/@hi.bearth.nft" target="_blank" rel="noopener noreferrer"><BiLogoMediumOld /></a>
            </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
